import axios from 'axios';
import store from '../'

const state = {
    menuOptions: {
        profile: {
            type: '',
            name: "Profile",
            url: '/users/profile',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        shoppingCart: {
            type: '',
            name: "My Builds",
            url: '/users/mybuild',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
    },
    adminOptions: {
        profile: {
            type: '',
            name: "Profile",
            url: '/users/profile',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        addPart: {
            type: '',
            name: "All Parts",
            url: '/users/items-controller',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        shoppingCart: {
            type: '',
            name: "My Builds",
            url: '/users/mybuild',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
    }
};
const getters = {
    allAdminOptions: (state) => {
        console.log('getting options, checking user ', store.getters.getUser)
        if(store.getters.getUser && store.getters.getUser.is_admin == 1){
            return state.adminOptions
        }
        else {
            return state.menuOptions
        }
    },
};
const actions = {

};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}